const DEFAULT_OPTIONS = {
    root: null,
    threshold: 0.25,
    rootMargin: '0px',
};

/**
 * CustomIntersectionObserver
 *
 * Initializes a Intersection Observer on the window object.
 */
export class CustomIntersectionObserver {
    /**
     * @param intersectionObserverEntry - IntersectionObserverEntry to be observed.
     * @param callback - Callback function which is executed when a HTMLElement intersects or not.
     * @param options - Custom IntersectionObserver options -> default to DEFAULT_OPTIONS.
     */
    configure(
        intersectionObserverEntry,
        callback,
        options = DEFAULT_OPTIONS
    ) {
        this.intersectionObserverEntry = intersectionObserverEntry;
        this.callback = callback;
        this.options = options;
    }

    /**
     * @returns {object}
     */
    get getOptions() {
        return this.options;
    }

    /**
     * @returns {function(): void}
     */
    get getCallback() {
        return this.callback;
    }

    /**
     * @param intersectionObserverEntry - IntersectionObserverEntry[].
     */
    stopObserving(intersectionObserverEntry) {
        this.observer.unobserve(intersectionObserverEntry.target);
    }

    initObserver() {
        this.observer = new IntersectionObserver(
            (intersectionObserverEntries) => intersectionObserverEntries
                .forEach(this.getCallback),
            this.getOptions
        );
    }
}
